import { render, staticRenderFns } from "./receOffsetPay.vue?vue&type=template&id=f348907a&scoped=true"
import script from "./receOffsetPay.vue?vue&type=script&lang=js"
export * from "./receOffsetPay.vue?vue&type=script&lang=js"
import style0 from "./receOffsetPay.vue?vue&type=style&index=0&id=f348907a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f348907a",
  null
  
)

export default component.exports